import download from 'downloadjs'
import _ from 'lodash'
import { computed, ref } from 'vue'
export const useRegistryUtils = (registros, colunas) => {
	const page = ref(1)
	const pageSize = ref(10)

	const searchTerm = ref()

	const firstIndex = computed(() => {
		return pageSize.value * page.value - (pageSize.value - 1)
	})

	const lastIndex = computed(() => {
		return pageSize.value * page.value > registros.value.length
			? registros.value.length
			: pageSize.value * page.value
	})

	const pageData = computed(() => {
		return sortedData.value
			? sortedData.value
					.filter((registro) => {
						return searchTerm.value
							? Object.values(registro)
									.toString()
									.toLocaleLowerCase()
									.includes(searchTerm.value.toLocaleLowerCase())
							: registro
					})
					.slice(firstIndex.value - 1, lastIndex.value)
			: []
	})

	const entriesToDelete = ref([])

	function onPageChange({ currentPageSize, currentPage }) {
		pageSize.value = currentPageSize
		page.value = currentPage
	}

	const totalRegistries = computed(() => {
		return (searchTerm.value ? pageData.value.length : registros.value?.length) || 0
	})

	function downloadExemplo() {
		const keys = Object.keys(registros.value[0]).filter((f) =>
			colunas.value.map((m) => m.key).includes(f),
		)
		const rows = registros.value.map((dado) => keys.map((k) => dado[k]))

		const header = keys.map((m) =>
			colunas.value
				.find((f) => f.key === m)
				?.nome.normalize('NFD')
				.replace(/[^a-zA-Z\s]/g, ''),
		)

		const csv = [
			header, // header row first
			...rows,
		]
			.map((m) => m.join(';'))
			.join('\r\n')

		download(csv, 'grid', 'text/csv')
	}

	const sortBy = ref()
	const sortedData = computed(() => {
		if (sortBy.value) {
			return _.sortBy(registros.value, sortBy.value.keys, sortBy.value.directions)
		}

		return registros.value
	})

	const tablePlaceholderType = computed(() => {
		if (searchTerm.value && !pageData.value.length) return 'termNotFound'
		else if (registros.value === undefined) return 'pending'
		else if (registros?.value?.length === 0) return 'empty'
		else return ''
	})

	return {
		page,
		pageSize,
		searchTerm,
		pageData,
		entriesToDelete,
		onPageChange,
		firstIndex,
		lastIndex,
		totalRegistries,
		downloadExemplo,
		sortBy,
		sortedData,
		tablePlaceholderType,
	}
}
